export enum EViewType {
  Multis = 'Multis',
  SGM = 'SGM',
  Others = 'Others',
}
